export default __webpack_public_path__ + "static/media/alphabet-yellow-k.f03e63e4.png";